import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  endScreen: {
    zIndex: `${theme.zIndex.dialog + 1} !important`,
    top: 0,
  },
}));
